<div class="auth-page auth-page--flow">
  <div class="auth-page__grid">
    <app-auth-showcase-aside />

<main
      class="auth-main auth-main--flow"
      [class.auth-main--dense]="loginStep !== 'hub'"
    >
      <div class="auth-main__content">
        <nav class="auth-mobile-nav" [attr.aria-label]="'auth.login.back' | translate">
          @if (loginStep === 'hub') {
            <a
              class="auth-back auth-back--icon"
              routerLink="/authentication"
              [attr.aria-label]="'auth.login.back' | translate"
            >
              <i-tabler name="chevron-left" class="auth-back__icon flex"></i-tabler>
            </a>
          } @else {
            <button
              type="button"
              class="auth-back auth-back--icon"
              (click)="backToHub()"
              [attr.aria-label]="'auth.login.back' | translate"
            >
              <i-tabler name="chevron-left" class="auth-back__icon flex"></i-tabler>
            </button>
          }
        </nav>

        <a class="auth-brand" [routerLink]="['/authentication']">
          <img
            src="/assets/images/logos/logo.svg"
            class="auth-brand__logo"
            [attr.alt]="'auth.login.logoAlt' | translate"
          />
        </a>

        <div class="auth-panel">
          @if (sessionExpired) {
            <div class="auth-info-banner auth-info-banner--warn" role="status">
              <p class="auth-info-banner__text">{{ 'auth.welcome.sessionExpired' | translate }}</p>
            </div>
          }

          @if (loginStep === 'hub') {
            <h1 class="auth-panel__title">{{ 'auth.login.title' | translate }}</h1>
            <p class="auth-panel__hint">{{ 'auth.login.infoBanner' | translate }}</p>

            @if (showCreateBusinessHint) {
              <div class="auth-info-banner auth-info-banner--claim" role="status">
                <mat-icon class="auth-info-banner__icon" aria-hidden="true">storefront</mat-icon>
                <p class="auth-info-banner__text">{{ 'auth.login.createBusinessHint' | translate }}</p>
              </div>
            }

            <app-auth-google-signin-button
              class="auth-google-btn--hub"
              text="signin_with"
              [label]="'auth.login.googleCta' | translate"
              [loadingLabel]="
                isSubmitting
                  ? ('auth.login.googleSubmitting' | translate)
                  : ('auth.login.googleLoading' | translate)
              "
              [visible]="showGoogleSignIn"
              [loading]="googleAuthInitializing || isSubmitting"
            />

            @if (googleLoginError) {
              <div class="auth-google-error">
                <p class="auth-google-error__text">{{ googleLoginError }}</p>
                <a
                  class="auth-google-error__link"
                  [routerLink]="['/authentication/register']"
                  [queryParams]="googlePrefillEmail ? { email: googlePrefillEmail } : {}"
                >
                  {{ 'auth.login.googleRegisterCta' | translate }}
                </a>
              </div>
            }

            <button
              mat-flat-button
              color="primary"
              type="button"
              class="auth-btn-primary"
              (click)="openCredentialsStep()"
            >
              {{ 'auth.login.continueWithEmail' | translate }}
            </button>
          } @else {
            <div class="auth-panel__top">
              <button type="button" class="auth-back" (click)="backToHub()">
                <mat-icon aria-hidden="true">arrow_back</mat-icon>
                {{ 'auth.login.back' | translate }}
              </button>
            </div>

            <h1 class="auth-panel__title">{{ 'auth.login.credentialsTitle' | translate }}</h1>
            <p class="auth-panel__subtitle">{{ 'auth.login.credentialsSubtitle' | translate }}</p>

            @if (showCreateBusinessHint) {
              <div class="auth-info-banner auth-info-banner--claim" role="status">
                <mat-icon class="auth-info-banner__icon" aria-hidden="true">storefront</mat-icon>
                <p class="auth-info-banner__text">{{ 'auth.login.createBusinessHint' | translate }}</p>
              </div>
            }

            <form class="auth-form" [formGroup]="form" (ngSubmit)="submit()" authScrollOnFocus>
              <mat-form-field appearance="outline" color="primary" subscriptSizing="dynamic">
                <mat-label>{{ 'auth.login.email' | translate }}</mat-label>
                <input
                  #emailInput
                  matInput
                  type="email"
                  inputmode="email"
                  autocomplete="username"
                  formControlName="uname"
                />
                <!-- mat-error siempre presente; Material lo muestra fuera del outline en errorState. -->
                <mat-error>
                  @if (f['uname'].hasError('required')) {
                    {{ 'auth.login.emailRequired' | translate }}
                  } @else if (f['uname'].hasError('pattern')) {
                    {{ 'auth.login.emailInvalid' | translate }}
                  }
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" color="primary" subscriptSizing="dynamic">
                <mat-label>{{ 'auth.login.password' | translate }}</mat-label>
                <input
                  matInput
                  [type]="hidePassword ? 'password' : 'text'"
                  autocomplete="current-password"
                  formControlName="password"
                />
                <button
                  mat-icon-button
                  matSuffix
                  type="button"
                  [attr.aria-label]="hidePassword ? 'Mostrar contraseña' : 'Ocultar contraseña'"
                  (click)="hidePassword = !hidePassword"
                >
                  <mat-icon>{{ hidePassword ? 'visibility' : 'visibility_off' }}</mat-icon>
                </button>
                <mat-error>
                  @if (f['password'].hasError('required')) {
                    {{ 'auth.login.passwordRequired' | translate }}
                  }
                </mat-error>
              </mat-form-field>

              <div class="auth-form-actions">
                <mat-checkbox color="primary" formControlName="rememberDevice">{{
                  'auth.login.rememberDevice' | translate
                }}</mat-checkbox>
                <a [routerLink]="['/authentication/forgot-password']">{{ 'auth.login.forgotPassword' | translate }}</a>
              </div>

              <button
                mat-flat-button
                color="primary"
                class="auth-btn-primary"
                type="submit"
                [disabled]="isSubmitting"
              >
                @if (isSubmitting) {
                  <mat-spinner diameter="20" aria-hidden="true"></mat-spinner>
                  {{ 'auth.login.submitting' | translate }}
                } @else {
                  {{ 'auth.login.submit' | translate }}
                }
              </button>

              @if (errorMessage) {
                <p class="auth-form-error" role="alert">{{ errorMessage }}</p>
              }
            </form>
          }
        </div>

        <p class="auth-footer">
          {{ 'auth.login.registerPrompt' | translate }}
          <a [routerLink]="['/authentication/register']">{{ 'auth.login.registerLink' | translate }}</a>
        </p>
      </div>
    </main>
  </div>
</div>
